export type AuthLoginMode = 'portal' | 'legacy';

const AUTH_MODE_KEY = 'authMode';

interface LegacyJwtPayload {
  portal?: string;
  resourceId?: number;
  lobId?: number;
}

/** Keep authMode aligned with the stored JWT (legacy is the default path). */
export function syncAuthModeFromToken(): void {
  const token = localStorage.getItem('accessToken');
  if (!token) return;

  try {
    const decoded = JSON.parse(atob(token.split('.')[1] || '')) as LegacyJwtPayload;
    localStorage.setItem(AUTH_MODE_KEY, decoded?.portal ? 'portal' : 'legacy');
  } catch {
    localStorage.setItem(AUTH_MODE_KEY, 'legacy');
  }
}

export const isLegacyAuthMode = (): boolean => {
  syncAuthModeFromToken();
  return localStorage.getItem(AUTH_MODE_KEY) === 'legacy';
};

export const getLegacyAuthLoginUrl = (): string =>
  `${window.env.API_URL}/api/v1/auth/login`;

export function setPortalAuthMode(): void {
  localStorage.setItem(AUTH_MODE_KEY, 'portal');
}

export function setLegacyAuthMode(): void {
  localStorage.setItem(AUTH_MODE_KEY, 'legacy');
  localStorage.removeItem('permissions');
  localStorage.removeItem('role');
}

export function clearAuthMode(): void {
  localStorage.removeItem(AUTH_MODE_KEY);
}

/** Legacy login: full UI access (no RBAC permissions in token). */
export function legacyPermissionBypass(): boolean {
  return isLegacyAuthMode();
}
